export default "__VITE_ASSET__BKCi07z$__"